import axios from 'axios'

const sigcarApiBase = 'https://ejes.sigcar.es/api'

const sigcarApiClient = axios.create({
  baseURL: sigcarApiBase,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export { sigcarApiClient }
